import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { BottomActiveBar } from "../../Icons";
import RolesList from "./RolesList";
import RoleHeader from "./RoleHeader";
import RoleInformation from "../../components/RoleManagement/RoleInformation/RoleInformation";
import { UnoStoreHooks } from "@simulanisindia/ui";
import apiClient from "../../apiClient";
import { ALL_PERMISSION_LIST } from "../../apiClient/apiEndpoints";
import { checkPermissionExist, getPlaceholderName } from "../../utils/general";
import { ROLES_EDIT_PERMISSION } from "../../constant/permission";
import PermissionMobile from "./PermissionMobile";
import NoDataFound from "../../components/NoDataFound";

const { useUnoSelector } = UnoStoreHooks;

const TabRole = ({
  isMobileView,
  //   onlyView = false,
  //   fetRoleUserLoading,
  //   getRoleUsers,
  //   errors,
  roleUserList = [],
  //   selectedTab,
  //   heading,
  //   name,
  //   setName,
  //   description,
  //   setDescription,
  //   UUID = null,
  //   selectPermissions,
  //   setSelectPermissions,
  //   selectedUsers,
}) => {
  const configData = useUnoSelector((state) => state.config);
  const [permissionList, setPermissionList] = useState({});
  const [activeTab, setActiveTab] = useState("demo2");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [showBackBtn, setShowBackBtn] = useState(true);

  const getAllPermission = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${ALL_PERMISSION_LIST}`);
      setPermissionList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllPermission();
  }, []);

  const findPermission = (key) => {
    let list = permissionList?.children?.find((e) => e.name.toLowerCase() === key.toLowerCase()) || [];
    return list;
  };

  let checkEditPermission = checkPermissionExist(ROLES_EDIT_PERMISSION);

  //   const [selectedSubTab, setSelectedSubTab] = useState("subtab-0");

  //   const subTabs = [
  //     ,
  //     {
  //       key: "Team",
  //       navItem: { title: "Team " },
  //       content: {
  //         component: () => (
  //           <>
  //             <h1> hello team</h1>
  //           </>
  //         ),
  //       },
  //     },
  //     {
  //       key: "Resource ",
  //       navItem: { title: "Resource " },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },
  //     {
  //       key: "Training",
  //       navItem: { title: "Training " },
  //       content: {
  //         component: () => (
  //           <>
  //             {" "}
  //             <>
  //               <h1> hello team</h1>
  //             </>
  //           </>
  //         ),
  //       },
  //     },
  //     {
  //       key: "Guiding",
  //       navItem: { title: "Guiding " },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },

  //     {
  //       key: "Collaborating",
  //       navItem: { title: "Collaborating" },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },
  //     {
  //       key: "Content ",
  //       navItem: { title: "Content Management " },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },
  //     {
  //       key: "General ",
  //       navItem: { title: "General Permissions" },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },
  //     {
  //       key: "Productivity",
  //       navItem: { title: "Productivity" },
  //       content: {
  //         component: () => <></>,
  //       },
  //     },
  //   ];

  //   const renderSubTabs = () => (
  //     <>
  //       <div className="for-tabs mobile">
  //         <Tab.Container activeKey={selectedSubTab} onSelect={setSelectedSubTab}>
  //           <div className="tabsMobile">
  //             <Nav variant="pills" className="tabfull tab-roles">
  //               {subTabs.map((item, index) => (
  //                 <Nav.Item key={item.key}>
  //                   <Nav.Link eventKey={item.key}>
  //                     <span className="tabText">{item.navItem.title}</span>
  //                     <span className="activeIndicator">
  //                       <BottomActiveBar />
  //                     </span>
  //                   </Nav.Link>
  //                 </Nav.Item>
  //               ))}
  //             </Nav>
  //           </div>
  //           <Tab.Content>
  //             {subTabs.map((item) => (
  //               <Tab.Pane eventKey={item.key} key={item.key}>
  //                 {item.content.component()}
  //               </Tab.Pane>
  //             ))}
  //           </Tab.Content>
  //         </Tab.Container>
  //       </div>
  //     </>
  //   );

  const handleClick = (selectedKey) => {
    setActiveTab(selectedKey);
  };

  const allApplicationsWithTabs = [
    {
      key: "demo1",
      navItem: { title: "Role Information " },
      content: {
        component: () => (
          <>
            <RoleInformation
              isMobileView={isMobileView}
              //   onlyView={!checkEditPermission || onlyView}
              //   errors={errors}
              //   heading={heading}
                name={name}
                setName={setName}
                description={description}
                setDescription={setDescription}
            />{" "}
          </>
        ),
      },
    },
    {
      key: "demo2",
      navItem: { title: "Role Assignments   " },
      content: {
        component: () => (
          <>
            {isMobileView && (
              <div className="role-card">
                <div className="role-table">
                  {roleUserList.length > 0 ? (
                    <>
                      {" "}
                      {roleUserList.map((user) => (
                        <div className="roleCate-user">
                          <span className="initials"> {getPlaceholderName(user.name)} </span>
                          <div className="name-des">
                            <h6> {user.name} </h6>
                            <p> {user.group.name} </p>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {" "}
                      <div className="no-data2 pt-4">
                        <NoDataFound headText="No User found" infoText="" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </>
        ),
      },
    },
    {
      key: "demo3",
      navItem: { title: "Permissions" },
      content: {
        // component: () => renderSubTabs(), // uses the subtab UI
        component: () => (
          <>
            <PermissionMobile />
          </>
        ),
      },
    },
  ];

  return (
    <>
      <div className="role-page">
        <RoleHeader isMobileView={isMobileView} showBackBtn={showBackBtn} roleheader={false} />

        <div className="for-tabs mobile roletabcont">
          <Tab.Container activeKey={activeTab} onSelect={handleClick}>
            <div className="tabsMobile">
              <Nav variant="pills" className="tabfull tab-role">
                {allApplicationsWithTabs.map((item) => (
                  <Nav.Item key={item.key}>
                    <Nav.Link eventKey={item.key}>
                      <span className="tabText">{item.navItem.title}</span>
                      <span className="activeIndicator">
                        <BottomActiveBar />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
            <Tab.Content>
              {allApplicationsWithTabs.map((item) => (
                <Tab.Pane eventKey={item.key} key={item.key}>
                  {item.content.component()}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default TabRole;
